import { render } from "./ManualPaymentView.vue?vue&type=template&id=f605ed44"
import script from "./ManualPaymentView.vue?vue&type=script&lang=js"
export * from "./ManualPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__